module.exports = __webpack_public_path__ + "img/img_44@2x.503921f5.png";